import { render } from "./AdmData.vue?vue&type=template&id=27e8ddba&scoped=true&ts=true"
import script from "./AdmData.vue?vue&type=script&lang=ts"
export * from "./AdmData.vue?vue&type=script&lang=ts"

import "./AdmData.vue?vue&type=style&index=0&id=27e8ddba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e8ddba"]])

export default __exports__